<template>
  <div id="event">
    <!--
    <div class="row mt-md-5 future">
      <div class="col-md-12">
        <img src="/static/images/event/title.png" class="img-fluid" alt="これからの予定">
      </div>
      <div class="col-md-12 cristmas-title">
        クリスマスシーズン限定!体験読み聞かせ「絵本に飛び込むX’mas!」
      </div>
      <div class="col-md-12">
        <img src="/static/images/event/20.1130_xmas.png" class="img-fluid" alt="クリスマス">
      </div>
      <div class="col-md-12">
        <p>
          友だちにも会えないかもしれないさみしいクリスマスが、忘れられない楽しいクリスマスになれたらいい。そう願って、絵本の中に飛びこんでいくような気持ちで、絵本を楽しめる、リモートでの体験読みきかせ「絵本に飛びこむX’mas」を考えました。<br>
          2020年12月5日（土）～20（日）の毎週土日10時YouTube Live等で開催します!!
        </p>
        <div class="line-red"></div>
        <div class="cristmas-description">
          <p>クリスマスシーズン限定!体験読み聞かせ「絵本に飛び込むX’mas」</p>
          <p>開催日：
          <span>2020年12月5日(土)・6日(日)・12日(土)・13日(日)・19日(土)・20日(日)</span>
          </p>
          <p>時間：
          <span>午前10時～10時半くらいまで</span>
          </p>
          <p>開催方法：
          <span>YouTube Live ※誰でも視聴可能です</span>
          </p>
          <p>参加URL：
          <span><a href="https://www.youtube.com/channel/UCs8jILWqrBQyuyrmwjUUTiA">https://www.youtube.com/channel/UCs8jILWqrBQyuyrmwjUUTiA</a></span>
          </p>
          <p>参加費：
          <span>無料</span>
          </p>
          <p>
          <span>プレゼント企画もありますので、ぜひご参加ください!</span>
          </p>
        </div>
        <div class="line-red"></div>
        <div class="cristmas-description">
          <p>
          【Live配信内容】
          </p>
          <p>
            ＜12月5日(土)＞飛び込む絵本！！<br>
            絵本「パンダくんプレゼントのもりへ」の中へいくよ！<br>
            視聴URL：<span><a href="https://youtu.be/hTwhhyGTbA8" target="_blank">https://youtu.be/hTwhhyGTbA8</a></span><br>
            作家のむとうさんとヤスダさんが絵本の中にはいっていきます。<br>
            そうして、どうぶつさんたちの朝食のテーブルに座ったり、暗い暗いもりの中へ入っていったり、歌うジンジャークッキーを食べちゃったり、フクロウさんと歌ったり…。<br>
            そのとき、むとうさんと、ヤスダさんに大変なことが！！<br>
          </p>
          <br>
          <p>
            ＜12月6日(日)＞みんなで、うたって、おどろう！<br>
            視聴URL：<span><a href="https://youtu.be/unk5mRJ6HfY" target="_blank">https://youtu.be/unk5mRJ6HfY</a></span><br>
            絵本「パンダくんプレゼントのもりへ」の中に出てくる<br>
            フクロウさんともりのようせいの歌「リンリン ホー」をみんなと一緒に歌って踊ります。<br>
          </p>
          <br>
          <p>
            ＜12月12日(土)＞飛び込む絵本！！<br>
            絵本「パンダくんのおかいもの」の中へいくよ！！<br>
            視聴URL：<span><a href="https://youtu.be/0nT07GSqKGY" target="_blank">https://youtu.be/0nT07GSqKGY</a></span><br>
            作家のむとうさんとヤスダさんが絵本のなかにはいっていきます。<br>
            そうして、絵本に出てくる空にうかぶおんぷのパンを食べたり、クモさんのつくるからくち綿がしをたべたり…。<br>
            どんな味なんだろう？<br>
            最後は、みんなといっしょにタネタネダンスをします。<br>
          </p>
          <br>
          <p>
            ＜12月13日(日)＞みんなで、うたって、おどろう！<br>
            視聴URL：<span><a href="https://youtu.be/js9ygTgnBGA" target="_blank">https://youtu.be/js9ygTgnBGA</a></span><br>
            絵本「パンダくんのおかいもの」中にでてくるタネタネダンスをみんなで歌って踊ります。<br>
          </p>
          <br>
          <p>
            ＜12月19日(土)＞飛び込む絵本！！<br>
            絵本「パンダくんのおかいもの」の中へいくよ！！<br>
            クリスマス直前！サンタもくる！<br>
            視聴URL：<span><a href="https://youtu.be/8lxe4brEa4g">https://youtu.be/8lxe4brEa4g</a></span><br>
            なんとふわふわメレンゲや、うたうジンジャークッキーが飾られているもみの木と一緒におとどけする飛び込む絵本。<br>
            作家のむとうさんとヤスダさんといっしょに絵本の中に飛びこんでいきます。<br>
            みんなといっしょにクリスマスのタネタネダンスをしよう！<br>
            最後にサンタさんも登場。サンタさんからのプレゼントがあります。<br>
          </p>
          <br>
          <p>
            ＜12月20日(日)＞飛び込む絵本！！<br>
            絵本「パンダくんプレゼントのもりへ」の中へいくよ！！<br>
            クリスマス直前！サンタもくる！<br>
            視聴URL：<span><a href="https://youtu.be/brno2rwnb3o">https://youtu.be/brno2rwnb3o</a></span><br>
            なんとふわふわメレンゲや、うたうジンジャークッキーが飾られているもみの木と一緒におとどけする飛び込む絵本。作家のむとうさんとヤスダさんといっしょに絵本の中に飛びこんでいきます。<br>
            みんなといっしょにクリスマスのリンリンホーダンスをしよう。<br>
            最後にサンタさんも登場。サンタさんからのプレゼントがあります。<br>
          </p>
        </div>
      </div>
      <div class="col-md-12 line">
        <img src="/static/images/event/line.png" class="img-fluid" alt="黄色の破線">
      </div>
    </div>
    -->
    <div class="row mt-md-5 past">
      <div class="col-md-12 past-title">
        <img src="/static/images/event/title-past.png" class="img-fluid" alt="いろいろやってきました">
      </div>
      <div class="col-6 past-event" v-for="event in events" >
        <router-link :to="{ name: 'EventArchive', params: { code: event.code }}">
          <img :src="`/static/images/event/archive/${event.code}/${event.image}`" class="img-fluid" :alt="`${event.date} ${event.title}のサムネイル`">
        </router-link>
        <div class="detail row">
          <div class="col-md-6 col-sm-12 date">{{event.date}}</div>
          <div class="col-md-6 col-sm-12 d-flex justify-content-md-end justify-content-sm-start">
            <div v-for="tag in event.tag">
              <div class="tag badge badge-secondary" v-bind:class="`${tag.class}`"><span>{{tag.name}}</span></div>
            </div>
          </div>
          <div class="title col-md-12" v-html="event.title"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    title: '体験する絵本展と読み聞かせなど',
    name: 'event',
    data() {
      return {
        events: []
      };
    },
    mounted() {
      this.load();
    },
    updated: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    },
    methods: {
      load: function(params) {
        axios.get("/static/data/events.csv")
          .then( response => {
            if (response.status == 200) {
              var data = response.data.split('\n');
              var keys = data[0].split(',');
              var list = [];
              for(var i=1;i<data.length-1;++i){
                var values = data[i].split(',');
                var event = {};
                keys.forEach( function( key, idx ) {
                  if(key == "tag") {
                    var arr = values[idx].split('/');
                    event[key] = arr.map(tag => {
                      let class_name;
                      switch(tag) {
                        case '読み聞かせ':
                          class_name = "read";
                          break;
                        case 'グッズ':
                          class_name = "goods";
                          break;
                        case '絵本原画展':
                          class_name = "exhibition-genga";
                          break;
                        case '体験絵本展':
                          class_name = "exhibition-taiken";
                          break;
                        case 'その他':
                          class_name = "other";
                          break;
                      }
                      return ( 
                        { 
                          name: tag, 
                          class: class_name
                        } 
                      )
                    })
                  } else {
                    event[key] = values[idx]
                  }
                })
                if(event) {
                  list.push(event);
                }
              }
              this.events = list.reverse();
              console.log("loaded events list");
            } else {
              alert(t("fail_to_get_data"))
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Event.vue